import { Component } from 'react';
import PropTypes from 'prop-types';


const breakpoints = {
    'xs': 320,
    'sm': 768,
    'md': 1024,
    'lg': 1680,
    'xl': 1680,
    'xxl': 1680,
}


class Breakpoint extends Component {
    static = {
        max: PropTypes.string,
        min: PropTypes.string
    }

    constructor(props) {
        super(props);
        const {max, min} = props;
        const mediaQueries = [];
        if ('max' in props) {
            mediaQueries.push(`(max-width: ${breakpoints[max] - 1}px)`);
        }
        if ('min' in props) {
            mediaQueries.push(`(min-width: ${breakpoints[min]}px)`);
        }
        this.mql = matchMedia(mediaQueries.join(' and '));
        this.state = {
            matches: this.mql.matches
        }
    }

    handleChangeBreakpoint = ({matches}) => {
        this.setState({
            matches: matches
        });
    }

    componentDidMount() {
        this.mql.addListener(this.handleChangeBreakpoint);
    }

    componentWillUnmount() {
        this.mql.removeListener(this.handleChangeBreakpoint);
    }

    render() {
        const {children} = this.props;
        const {matches} = this.state;

        if (matches) {
            return children;
        }
        return null;
    }
}

export default Breakpoint;



// WEBPACK FOOTER //
// ./src/components/layout/Breakpoint.js